/* eslint-disable */
import { FILTER_ADDRESS_REMOVED } from '../Filters.types';

/**
 * Action to remove the address from the filters
 * @param {Array} address The address
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_REMOVED>>} The created `Action`
 */
const filtersRemoveAddress = (address) => ({ fromPayload }) => {
  return fromPayload(address, { debounce: true }, FILTER_ADDRESS_REMOVED);
};

export default filtersRemoveAddress;
